import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["availableOperation", "secondaryButtonUse", "primaryButtonUse"];
import { useMemo } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import ApprovalOperationI18n from '../i18n/ApprovalOperationI18n';
import withErrorBoundary from '../../hoc/withErrorBoundary';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { useApprovalContext } from '../../hooks/useApprovalContext';
import { ApprovalOperation } from '../../types/ApprovalOperation';
import FormattedMessage from 'I18n/components/FormattedMessage';
import useApprovalConditions from '../../hooks/useApprovalConditions';
import { ApprovalDataLoadingSpinner } from '../common/ApprovalDataLoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
function ApprovalButton(props) {
  const {
      availableOperation,
      secondaryButtonUse,
      primaryButtonUse
    } = props,
    buttonProps = _objectWithoutPropertiesLoose(props, _excluded);
  const approval = useApprovalContext();
  const {
    isFetchComplete
  } = useApprovalConditions();

  // The meta.approvalOperation is used to support the ContenttEditorUI - they use their own
  // logic instead of the ApprovalButtons, and they do not currently use 'REJECT'.
  // (ContentEditorUI/static/js/components/approvals/EditorApprovalButtons.tsx)
  const approvalOperation = availableOperation || approval.meta.approvalOperation;
  const use = useMemo(() => {
    if (approvalOperation === ApprovalOperation.RECALL) {
      return secondaryButtonUse || 'secondary';
    }
    return primaryButtonUse || 'primary';
  }, [approvalOperation, primaryButtonUse, secondaryButtonUse]);
  const onClickButton = () => {
    approval.meta.setCurrentOperation(approvalOperation);
    approval.meta.setShowModal(true);
  };

  // Added loading check here as some apps are using ApprovalButton directly
  if (!isFetchComplete) {
    return /*#__PURE__*/_jsx(ApprovalDataLoadingSpinner, {});
  }
  if (!approvalOperation) {
    return null;
  }
  return /*#__PURE__*/_jsx(Tooltip, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.noAccessTooltip"
    }),
    disabled: !buttonProps.disabled,
    children: /*#__PURE__*/_jsx(Button, Object.assign({
      role: "button"
    }, buttonProps, {
      use: use,
      "data-test-id": `product-approvals-approval-button-${approvalOperation}`,
      onClick: onClickButton,
      children: /*#__PURE__*/_jsx(ApprovalOperationI18n, {
        approvalOperation: approvalOperation,
        approvalType: approval.meta.approvalType
      })
    }))
  });
}
export { ApprovalButton };
export default withErrorBoundary(ApprovalButton, 'ApprovalButton');